import { Button, Typography } from "@mui/material";
/* eslint-disable @typescript-eslint/no-unused-vars */
import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import serviceFaturaInstalacao from "../../../../services/serviceFaturaInstalacao";
import { toast } from "react-toastify";
import { useState } from "react";

export interface IDialogProps {
    open: boolean;
    onClose?: any;
    onSave?: any;
}

export default function DialogApproveAll({ open, onClose, onSave }: IDialogProps) {
    const [isDisable, setDisable] = useState(false);

    const handleRequest = async () => {
        setDisable(true);

        serviceFaturaInstalacao
            .approveAll()
            .then((result) => {
                if (result) {
                    toast.success("Faturas aprovadas com sucesso!");
                    onSave();
                    onClose();
                }
            })
            .finally(() => {
                setDisable(false);
            });
    };

    return (
        <div>
            <Dialog
                maxWidth="md"
                fullWidth
                onClose={(_, reason) => {
                    if (reason !== "backdropClick") {
                        onClose();
                    }
                }}
                open={open}
            >
                <DialogTitle>
                    Aprovar Todas
                    <IconButton
                        aria-label="close"
                        onClick={onClose}
                        sx={{
                            position: "absolute",
                            right: 8,
                            top: 8,
                            // color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent dividers>
                    <Typography>Tem certeza que deseja aprovar todas as faturas em branco?</Typography>
                </DialogContent>
                <DialogActions style={{ display: "flex", justifyContent: "center", margin: "24px" }}>
                    <Button
                        onClick={onClose}
                        color="warning"
                        variant="contained"
                        style={{ width: "159px", height: "44px" }}
                    >
                        Cancelar
                    </Button>
                    <Button
                        onClick={() => handleRequest()}
                        color="primary"
                        variant="contained"
                        disabled={isDisable}
                        style={{ width: "159px", height: "44px" }}
                    >
                        Confirmar
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}
